import React, { useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  useGetLocationByIdQuery,
  useUpdateLocationMutation,
} from "AppQuries/master/Location/location";
import { locationValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import LocationForm from "Components/Form/LocationForm";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import { toast } from "core/Operations/toast";
const EditLocation = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const {
    data: locationData,
    isLoading,
    isError: isFetchingError,
    error: fetchingError,
  } = useGetLocationByIdQuery(
    {
      companyCode: userData?.companyCode,
      code: code,
    },
    {
      enabled: !!code,
    }
  );
  console.log(locationData);
  const {
    mutate: updateLocation,
    isPending,
    isError,
    error,
  } = useUpdateLocationMutation();
  const methods = useForm({
    defaultValues: {
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
    },
    resolver: yupResolver(locationValidation),
  });

  const { setValue } = methods;

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmit = (payload) => {
    payload.modifyDate = getCurrentFormattedDate();
    payload.modifyUser = userData.userName;
    updateLocation(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Location Updated Successfully.");
          // setTimeout(() => {
          navigate(`${all_routes.master}${all_routes.location}`);
          // }, 1000);
        } else {
          toast.warning("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  useEffect(() => {
    if (Array.isArray(locationData) && locationData.length > 0) {
      Object.keys(locationData[0]).forEach((key) => {
        setValue(key, locationData[0][key]);
      });
    }
  }, [locationData]);
  if (isError) return <Error404 error={error} />;
  if (isFetchingError) return <Error404 error={fetchingError} />;
  if (isLoading || isPending) return <LoadingSpinner />;
  return (
    <div>
     
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Edit Location</h4>
                    <h6>Edit your location </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Update Location</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Update
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}${all_routes.location}`}
                      className="btn btn-secondary"
                    >
                      <i className="fas fa-reply me-2"></i>
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    {/* <div className="card-header">
                      <h4 className="card-title">Edit Location</h4>
                    </div> */}
                    <div className="card-body">
                      <LocationForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default EditLocation;
